"use client";
import React from "react";
import FormProvider, { useFormik } from "providers/FormProvider";
import { Search } from "components/common/Formik";
import { assign, get, map } from "utils/lodash";
import { Select } from "components/common/Formik";
import { CATEGORIES } from "utils/constant";

import cx from "classnames";
const Comp = ({
  onSearch,
  parentForm,
  onChangeProvince,
  onChangeWard,
  onClearProvince,
  onClearWard,
  onChangeCategory,
}: {
  onSearch: (searchTerm: string) => void;
  parentForm: any;
  onChangeProvince: (province: string | number) => void;
  onChangeWard: (ward: string | number) => void;
  onChangeCategory: (category: string | number) => void;
  onClearProvince: () => void;
  onClearWard: () => void;
}) => {
  const category = get(parentForm, "values.category");
  const provinceOptions = get(parentForm, "selectOptions.provinces", []);
  const wardOptions = get(parentForm, "selectOptions.wards", []);
  const categories = get(parentForm, "selectOptions.categories", []);
  return (
    <div className="bg-white">
      <div className="flex flex-col container mx-auto p-6 gap-4">
        <Search
          name="searchTerm"
          placeholder="Tìm cửa hàng"
          onSearch={onSearch}
          enterButton
        />
        <div className="flex sm:flex-row flex-col gap-4">
          <Select
            wrapperClassName="w-full overflow-hidden"
            name="province"
            placeholder="Tỉnh/Thành phố"
            options={provinceOptions.map((item: any) => ({
              label: get(item, "name"),
              value: get(item, "id"),
            }))}
            onChange={onChangeProvince}
            onClear={onClearProvince}
          />
          <Select
            wrapperClassName="w-full overflow-hidden"
            name="ward"
            placeholder="Phường/Xã"
            options={wardOptions.map((item: any) => ({
              label: get(item, "name"),
              value: get(item, "id"),
            }))}
            allowClear
            onChange={onChangeWard}
            onClear={onClearWard}
          />
        </div>
        <div className="flex gap-4">
          {map(categories, (value, index) => {
            const cat: any = CATEGORIES.filter(
              (cat) => cat.code === value.code
            )[0];
            cat.id = value.id;
            return (
              <div
                onClick={() => {
                  if (get(cat, "code") === category) {
                    onChangeCategory("");
                  } else {
                    onChangeCategory(get(cat, "code"));
                  }
                }}
                key={`cat_${index}`}
                className={cx(
                  "flex flex-col items-center bg-gray-100 p-2 rounded-md border border-gray-200 text-gray-800",
                  {
                    ["bg-primary text-white"]: get(cat, "code") === category,
                  }
                )}
              >
                <span className="text-sm text-center ">{get(cat, "name")}</span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

const Wrapper = ({
  onChangeSearch,
  onChangeFilter,
  duration = 800,
  parentForm,
}: {
  onChangeSearch: (searchTerm: string) => void;
  onChangeFilter: (filters: any) => void;
  duration?: number;
  value?: string;
  parentForm: any;
}) => {
  const ref: any = React.useRef(false);

  const form: any = useFormik({
    initialValues: {
      searchTerm: get(parentForm, "values.searchTerm"),
      province: get(parentForm, "values.province"),
      ward: get(parentForm, "values.ward"),
    },
    onSubmit: async (values) => {
      onChangeFilter(values);
    },
  });
  let timer: NodeJS.Timeout | undefined = undefined;
  React.useEffect(() => {
    if (ref.current) {
      if (!!timer) clearTimeout(timer);
      timer = setTimeout(() => {
        if (!!onChangeSearch) {
          console.log("form.values.searchTerm", form.values.searchTerm);
          onChangeSearch(form.values.searchTerm);
        }
      }, duration);
    }
    return () => clearTimeout(timer);
  }, [form.values.searchTerm]);
  assign(form, {
    onSearch: (searchTerm: string) => {
      onChangeSearch(searchTerm);
    },
    onChangeProvince: (province: string) => {
      onChangeFilter({ province });
    },
    onChangeWard: (ward: string) => {
      onChangeFilter({ ward });
    },
    onClearProvince: () => {
      onChangeFilter({ province: undefined });
    },
    onClearWard: () => {
      onChangeFilter({ ward: undefined });
    },
    onChangeCategory: (category: string) => {
      onChangeFilter({ category });
    },
  });
  return (
    <FormProvider form={form}>
      <Comp
        onSearch={form.onSearch}
        parentForm={parentForm}
        onChangeProvince={form.onChangeProvince}
        onChangeWard={form.onChangeWard}
        onClearProvince={form.onClearProvince}
        onClearWard={form.onClearWard}
        onChangeCategory={form.onChangeCategory}
      />
    </FormProvider>
  );
};

export default Wrapper;
